import React, { useState, useEffect } from 'react'
import { ThemeContext, Text, Box, FormField, TextInput, CheckBox, Select, TextArea, SelectMultiple } from "grommet"
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import { Warn } from './Warn'

// Gurmit: Create another TTInputText for OnChange if needed. Not to add onChange here.
export const TTInputText = ({ name, label, data, help, required, disabled, customSize }) => {

    const [state, setState] = useState({
        value: data,
    });

    const onChange = event => {
        const {
            target: { value },
        } = event;
        setState({ value });
    };

    useEffect(() => {
        setState({
            value: data,
        })
    }, [data])

    return (
        <ThemeContext.Extend
            value={{
                formField: {
                    border: { position: 'outer', side: 'all' },
                },
            }}
        >
            <FormField
                name={name}
                contentProps={{ background: "light-3", border: { "size": "xsmall", "style": "solid", "side": "top" } }}
                label={
                    required ? (
                        <Box direction="column">
                            <Box direction="row">
                                <Text size="small" weight="bold">{label}</Text>
                                <Text color="status-critical">*</Text>
                            </Box>
                        </Box>
                    ) : (
                        <Box direction="column">
                            <Box direction="row">
                                <Text size="small" weight="bold">{label}</Text>
                            </Box>
                        </Box>
                    )
                }
                value={state.value}
                help={<Text size="xsmall">{help}</Text>}
                component={TextInput}
                required={required}
                disabled={disabled}
                onChange={onChange}
            />
        </ThemeContext.Extend>
    )
}

export const TTInputTextSuggestions = ({ name, label, data, help, required, disabled, customSize, allSuggestions, suggestionCheck = false, suggestionNotFoundWarn = "" }) => {

    const [suggestions, setSuggestions] = React.useState(allSuggestions);
    const [value, setValue] = React.useState(data);

    const onChange = (event) => {
        const nextValue = event.target.value;
        setValue(nextValue);
        if (!nextValue) setSuggestions(allSuggestions);
        else {
            const regexp = new RegExp(`^${nextValue}`);
            setSuggestions(allSuggestions.filter((s) => regexp.test(s)));
        }
    };

    const onSuggestionSelect = (event) => {
        setValue(event.suggestion);
    };

    return (
        <ThemeContext.Extend
            value={{
                formField: {
                    border: { position: 'outer', side: 'all' },
                },
            }}
        >
            {value && !suggestions.includes(value) && suggestionCheck &&
                <Box margin={{ bottom: "small" }}>
                    <Warn warning={`${value} not found`} subWarning={suggestionNotFoundWarn} />
                </Box>
            }

            <FormField
                name={name}
                contentProps={{ background: "light-3", border: { "size": "xsmall", "style": "solid", "side": "top" } }}
                label={
                    required ? (
                        <Box direction="column">
                            <Box direction="row">
                                <Text size="small" weight="bold">{label}</Text>
                                <Text color="status-critical">*</Text>
                            </Box>
                        </Box>
                    ) : (
                        <Box direction="column">
                            <Box direction="row">
                                <Text size="small" weight="bold">{label}</Text>
                            </Box>
                        </Box>
                    )
                }
                value={value}
                help={<Text size="xsmall">{help}</Text>}
                component={TextInput}
                required={required}
                disabled={disabled}
                onChange={onChange}
                onSuggestionSelect={onSuggestionSelect}
                suggestions={suggestions}
            />
        </ThemeContext.Extend>
    )
}

export const TTInputTextLarge = ({ name, label, data, help, required, disabled }) => {
    return (
        <FormField
            name={name}
            label={<Text weight="bold" color="brand" size="small">{label}</Text>}
            value={data}
            help={<Text size="xsmall">{help}</Text>}
            component={TextInput}
            required={required}
            disabled={disabled}
            resize
        />
    )
}

export const TTDataTimePicker = ({ name, label, data, help, required, maxDate, setValue }) => {

    const [selectedDate, setSelectedDate] = useState(data)
    useEffect(() => {
        setValue(selectedDate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate])


    return (
        <ThemeContext.Extend
            value={{
                formField: {
                    border: { position: 'outer', side: 'all' },
                },
            }}
        >
            <FormField
                pad
                name={name}
                label={<Text weight="bold" color="brand" size="small">{label}</Text>}
                value={selectedDate}
                help={<Text size="xsmall">{help}</Text>}
            >
                <DateTimePicker
                    format="dd MMM y HH:mm:ss"
                    onChange={(date) => {
                        setSelectedDate(date);
                    }}
                    value={selectedDate}
                    maxDate={maxDate}
                    name={name}
                />
            </FormField>
        </ThemeContext.Extend>
    )
}


export const TTInputPass = ({ name, label, data, help, required, disabled }) => {
    return (
        <FormField
            type="password"
            name={name}
            label={<Text weight="bold" color="brand" size="small">{label}</Text>}
            value={data}
            help={<Text size="xsmall">{help}</Text>}
            component={TextInput}
            required={required}
            disabled={disabled}
        />
    )
}

export const TTInputSelect = ({ name, label, data, defaultOptions, required, disabled, help }) => {
    const [options, setOptions] = useState([])
    const [selectedValue, setSelectedValue] = useState(data)

    return (
        <ThemeContext.Extend
            value={{
                formField: {
                    border: { position: 'outer', side: 'all' },
                },
            }}
        >
            <FormField help={<Text size="xsmall">{help}</Text>} label={<Text weight="bold" color="brand" size="small">{label} {required ? <Text color="red" size="small">*</Text> : null}</Text>}
                contentProps={{ background: "light-3", border: { "size": "xsmall", "style": "solid", "side": "top" } }}
                htmlFor="select">
                <Select
                    name={name}
                    disabled={disabled}
                    options={options.length === 0 ? defaultOptions : options}
                    value={selectedValue}
                    onChange={({ option }) => { setSelectedValue(option) }}
                    onSearch={text => {
                        const exp = new RegExp(text, "i");
                        setOptions(defaultOptions.filter(o => exp.test(o)))
                    }}
                    onClose={() => setOptions(defaultOptions)}
                    required={required}
                />
            </FormField>
        </ThemeContext.Extend>
    )
}

export const TTInputSelectMultiple = ({ name, label, selectedValues, defaultOptions, required, disabled, help }) => {
    const [options, setOptions] = useState(defaultOptions);
    const [value, setValue] = useState(selectedValues);

    return (
        <ThemeContext.Extend
            value={{
                formField: {
                    border: { position: 'outer', side: 'all' },
                },
            }}
        >
            <FormField help={<Text size="xsmall">{help}</Text>}
                label={<Text weight="bold" color="brand" size="small">{label} {required ? <Text color="red" size="small">*</Text> : null}</Text>}
                contentProps={{ background: "light-3", border: { "size": "xsmall", "style": "solid", "side": "top" } }}
                htmlFor="select">
                <SelectMultiple
                    value={value}
                    onSearch={(text) => {
                        const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
                        // Create the regular expression with modified value which
                        // handles escaping special characters. Without escaping special
                        // characters, errors will appear in the console
                        const exp = new RegExp(escapedText, 'i');
                        setOptions(defaultOptions.filter((o) => exp.test(o)));
                    }}
                    showSelectedInline
                    id={name}
                    name={name}
                    disabled={disabled}
                    options={options}
                    required={required}
                    onClose={() => {
                        setOptions(defaultOptions);
                    }}
                    onChange={({ value: nextValue }) => {
                        setValue(nextValue);
                    }}
                />
            </FormField>
        </ThemeContext.Extend>
    )
}

export const TTInputSelectExternal = ({ name, label, data, defaultOptions, required, setExternal, disabled }) => {
    const [options, setOptions] = useState([])
    const [selectedValue, setSelectedValue] = useState(data)

    return (
        <FormField label={<Text weight="bold" color="brand" size="small">{label} {required ? <Text color="red" size="small">*</Text> : null}</Text>}
            contentProps={{ background: "light-3", border: { "size": "xsmall", "style": "solid", "side": "top" } }}
            htmlFor="select">
            <Select
                name={name}
                disabled={disabled}
                options={options.length === 0 ? defaultOptions : options}
                value={selectedValue}
                onChange={({ option }) => {
                    setSelectedValue(option)
                    setExternal(option)
                }}
                onSearch={text => {
                    const exp = new RegExp(text, "i");
                    setOptions(defaultOptions.filter(o => exp.test(o)))
                }}
                onClose={() => setOptions(defaultOptions)}
                required={required}
            />
        </FormField>
    )
}



export const TTCheckBox = ({ name, label, checked, disabled }) => {
    const [checked_, setChecked_] = useState(false)

    useEffect(() => {
        if (checked) {
            setChecked_(true)
        }
    }, [checked])

    return (
        <FormField
            pad
        >
            <CheckBox
                id={name}
                disabled={disabled}
                name={name} label={label}
                checked={checked_}
                onChange={(event) => {
                    setChecked_(event.target.checked)
                }
                }
            />
        </FormField>
    )
}


export const TTTextArea = ({ name, label, data, size, disabled, required, fill = false, help = "" }) => {

    const [state, setState] = useState({
        value: data,
    });

    const onChange = event => {
        const {
            target: { value },
        } = event;
        setState({ value });
    };

    useEffect(() => {
        setState({
            value: data,
        })
    }, [data])

    return (
        <ThemeContext.Extend
            value={{
                formField: {
                    border: { position: 'outer', side: 'all' },
                },
            }}
        >
            <FormField
                name={name}
                component={TextArea}
                pad
                help={<Text size="xsmall">{help}</Text>}
                contentProps={{ background: "light-3", border: { "size": "xsmall", "style": "solid", "side": "top" } }}
                fill={fill}
                value={state.value}
                label={<Text weight="bold" color="brand" size="small">{label} {required ? <Text color="red" size="small">*</Text> : null}</Text>}
                size={size}
                disabled={disabled}
                onChange={onChange}
            />
        </ThemeContext.Extend>
    )
}
